import React, {useMemo, useState} from 'react'
import {CircularProgress, makeStyles, MenuItem, TextField} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    progress: {
        position: 'absolute',
        right: 2,
        top: 'calc(50% - 10px)'
    },
    root: {
        position: 'relative'
    },
    item: {
        minHeight: theme.spacing(4)
    }
}));

function SimpleSelect(
    {
        className,
        menuItemClassName,
        items,
        value = '',
        onChange = () => {
        },
        label,
        disabled,
        working,
        error
    }) {
    const classes = useStyles();
    const getItemProps = (item) => {
        const isStr = typeof item === 'string';
        const value = isStr ? item : item.value;
        const label = isStr ? item : item.label;
        return {value, label};
    }
    // eslint-disable-next-line
    const [fieldValue, setFieldValue] = useState(value);

    const fieldValueInput = useMemo(() => {
        const elem = items.find(x => {
            const isStr = typeof x === 'string';
            const xVal = isStr ? x : x.value;
            return value === xVal;
        });
        return elem ? getItemProps(elem).value : (items.length > 0 ? getItemProps(items[0]).value : null);
    }, [value, items]);
    const handleChange = event => {
        setFieldValue(event.target.value)
        onChange(event)
    }

    return (
        <div className={classes.root}>
            <TextField
                select
                helperText={error}
                error={!!error}
                fullWidth
                value={fieldValueInput}
                onChange={handleChange}
                label={label}
                className={className}
                disabled={disabled}
            >
                {items.map((item, i) => {
                    const {value, label} = getItemProps(item);
                    return (
                        <MenuItem key={i} className={clsx(classes.item, menuItemClassName)} value={value}>
                            {label}
                        </MenuItem>
                    )
                })}

            </TextField>
            {working && <CircularProgress className={classes.progress} size={20}/>}
        </div>
    )
}

SimpleSelect.propTypes = {
    classes: PropTypes.any,
    items: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.string.isRequired,
            }),
            PropTypes.string.isRequired,
        ])
    ),
    onChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.string
}

SimpleSelect.defaultProps = {}

export default SimpleSelect;